import { useState, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHistory } from "@fortawesome/free-solid-svg-icons";

interface LogButtonProps {
    log: string;
}

const LogButton: React.FC<LogButtonProps> = ({ log }) => {
    const [showLog, setShowLog] = useState(false);
    const [tooltipPosition, setTooltipPosition] = useState<"top" | "bottom">("top");
    const buttonRef = useRef<HTMLButtonElement>(null);

    const formattedLog = log ? log.replace(/ \| /g, "\n") : "No logs available";

    const handleMouseEnter = () => {
        if (buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            const spaceAbove = rect.top; // Distance from the top of the viewport to the button
            const headerHeight = 60; // Approximate height of the sticky header (adjust based on your `thead` height)

            // If the button is within the header height from the top (i.e., touching or near the sticky header)
            if (spaceAbove <= headerHeight) {
                setTooltipPosition("bottom"); // Show tooltip below
            } else {
                setTooltipPosition("top"); // Show tooltip above
            }
        }
        setShowLog(true);
    };

    return (
        <div className="relative flex items-center">
            <button
                ref={buttonRef}
                className="w-6 h-6 bg-[#757473] flex items-center justify-center rounded-md shadow hover:bg-[#8f8e8d] transition"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={() => setShowLog(false)}
            >
                <FontAwesomeIcon icon={faHistory} className="text-white text-sm" />
            </button>

            {showLog && (
                <div className="relative">
                    <div
                        className={`absolute z-[9999] left-[-16rem] transform p-2 text-xs text-white bg-black rounded-lg shadow-lg whitespace-pre-wrap min-w-max before:content-[''] before:absolute before:[left:240px] before:border-8 before:border-x-transparent ${tooltipPosition === "top"
                                ? "top-[-75px] before:top-full before:border-b-transparent before:border-t-black"
                                : "bottom-[-72px] before:bottom-full before:border-t-transparent before:border-b-black"
                            }`}
                    >
                        {formattedLog}
                    </div>
                </div>

            )}
        </div>
    );
};

export default LogButton;